import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { HelpersService } from '../../../../core/services/helpers.service';
import { OperationsService } from '../../../../core/services/operations.service';
import { TitoliFormComponent } from '../../../form/titoli/titoli-form.component';
import { SezioneTitoli } from '../../../models/sezioni/sezione-titoli';
import { TitoloEsecutivo } from '../../../models/titolo-esecutivo';
import { FormValidationService } from '../../../services/form-validation.service';

@Component({
    selector: 'div [titolo-form-add]',
  templateUrl: '../../../form/titoli/titoli-form.component.html',
  host: { '[class.col-sm-12]': '\'true\'', '[class.coldx]': '\'true\'' }
})

export class TitoloAddFormComponent extends TitoliFormComponent implements OnInit {

  idSezione: string;
  urlAddTitolo: string;
  idFascicolo: string;
  @Output()
  onReturn: EventEmitter<SezioneTitoli> = new EventEmitter<SezioneTitoli>();

  constructor(@Inject(OperationsService) operationService: OperationsService, @Inject(FormBuilder) campiForm: FormBuilder, @Inject(HelpersService) helpers: HelpersService, @Inject(FormValidationService) formValidationService: FormValidationService) {
    super(operationService, campiForm, helpers, formValidationService);
  }

  ngOnInit() {
    this.setTitle('Aggiungi Titolo');
    this.isInserimento(true);
  }

  getTitolo() {
    return new TitoloEsecutivo();
  }

  getRequest(request: TitoloEsecutivo) {
    this.operationService.addTitolo(this.urlAddTitolo, request, this.idSezione, this.idFascicolo).subscribe(response => this.updateSezioneTitoli(response));
  }

  updateSezioneTitoli(response) {
    if (response.returnCode === 'OK') {
      this.onReturn.emit(response.sezione);
    }
  }

  inizializza(url: string, idSezione: string, idFascicolo: string) {
    this.urlAddTitolo = url;
    this.idSezione = idSezione;
    this.idFascicolo = idFascicolo;
    this.createForm();
    this.populateSelect();
  }
}
